import { PATH_KPI } from "@/constants/URL";
import routerWithSidebar from "./routerWithSidebar";
export default {
  path: PATH_KPI,
  component: () =>
    import(/* webpackChunkName: "SidebarLayout" */ "@/layout/SidebarLayout/index.vue"),
  children: [
    {
      path: PATH_KPI,
      name: "kpidata",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/kpi/kpidata/index.vue")
      )
    }
  ]
};
